// import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import Swal from 'sweetalert2';

// interface CustomAlertProps {
//   action: 'Edit' | 'Delete' | 'Error' | 'Add' | 'info'; //| any ;
//   Title?: string;
//   msg?: string | any;
//   Timer?: number;
//   htmlContent?: string | any;
//   confirmButtonText?: string; // ✅ تمت إضافتها
// }

// export default function CustomAlert({
//   action,
//   msg,
//   Title,
//   Timer = 3000,
//   htmlContent,
//   confirmButtonText
// }: CustomAlertProps) {
//   let title = '';
//   let icon = '';
//   let text = '';

//   switch (action) {
//     case 'Edit':
//       title = Title ?? '';
//       text = msg ?? (i18n.language === 'ar' ? 'تمت عملية التعديل بنجاح' : 'Edit completed successfully');
//       icon = 'success';
//       break;
//     case 'Delete':
//       title = 'حذف';
//       text = i18n.language === 'ar' ? 'تمت عملية الحــذف بنجاح' : 'Delete completed successfully';
//       icon = 'warning';
//       break;
//     case 'Add':
//       title = Title ?? '';
//       icon = 'success';
//       text = msg ?? (i18n.language === 'ar' ? 'تمت عملية الإضافة بنجاح' : 'Add completed successfully');
//       break;
//     case 'Error':
//       // title =  "فشلت العملية";
//       title = Title ?? (i18n.language === 'ar' ? 'فشلت العملية' : 'Operation failed');
//       text = msg ?? '';
//       icon = 'warning';
//       break;
//     default:
//       title = title ?? '';
//       text = msg ?? '';
//       icon = 'info';
//   }

//   Swal.fire({
//     icon: icon as any,
//     title: title,
//     text: text,
//     timer: Timer,
//     background: 'var(--bs-body-bg)',
//     color: 'var(--bs-heading-color)',
//     // showConfirmButton: false, // Removes the "OK" button

//     // showConfirmButton: true, // ✅ لتفعيل الزر
//     showConfirmButton: confirmButtonText ? true : false, // ✅ يظهر فقط عند تمرير نص
//     confirmButtonText: confirmButtonText ?? (i18n.language === 'ar' ? 'موافق' : 'OK'), // ✅ نص الزر الافتراضي حسب اللغة

//     // allowOutsideClick: false, // Prevents closing when clicking outside
//     // allowEnterKey: false, // Allows
//     // iconColor:"var(--bs-theme)"
//     customClass: {
//       container: 'border',
//       popup: 'border border-theme border-3 rounded-3'
//     },

//     html: htmlContent
//   });
// }




interface CustomAlertProps {
  action: 'Edit' | 'Delete' | 'Error' | 'Add' | 'info';
  Title?: string;
  msg?: string | any;
  Timer?: number;
  htmlContent?: string | any;
  confirmButtonText?: string; // ✅ نص الزر اختياري
}

export default function CustomAlert({
  action,
  msg,
  Title,
  Timer = 3000,
  htmlContent,
  confirmButtonText
}: CustomAlertProps) {
  let title = '';
  let icon = '';
  let text = '';

  switch (action) {
    case 'Edit':
      title = Title ?? '';
      text = msg ?? (i18n.language === 'ar' ? 'تمت عملية التعديل بنجاح' : 'Edit completed successfully');
      icon = 'success';
      break;
    case 'Delete':
      title = 'حذف';
      text = i18n.language === 'ar' ? 'تمت عملية الحــذف بنجاح' : 'Delete completed successfully';
      icon = 'warning';
      break;
    case 'Add':
      title = Title ?? '';
      icon = 'success';
      text = msg ?? (i18n.language === 'ar' ? 'تمت عملية الإضافة بنجاح' : 'Add completed successfully');
      break;
    case 'Error':
      title = Title ?? (i18n.language === 'ar' ? 'فشلت العملية' : 'Operation failed');
      text = msg ?? '';
      icon = 'warning';
      break;
    default:
      title = title ?? '';
      text = msg ?? '';
      icon = 'info';
  }

  Swal.fire({
    icon: icon as any,
    title: title,
    text: text,
    timer: Timer,
    background: 'var(--bs-body-bg)',
    color: 'var(--bs-heading-color)',
    showConfirmButton: confirmButtonText ? true : false, // ✅ الزر يظهر فقط عند تمرير نص
    confirmButtonText:
      confirmButtonText ??
      (i18n.language === 'ar' ? 'موافق' : 'OK'), // ✅ النص الافتراضي عند الحاجة
    customClass: {
      container: 'border',
      popup: 'border border-theme border-3 rounded-3'
    },
    html: htmlContent
  });
}
